import { omit } from 'lodash';
import { defaultExerciseProgress, exerciseProgressWithRecord } from './ExerciseProgress';
export function defaultLessonProgress(lesson) {
    return {
        lessonId: lesson.id,
        rating: 0,
        passed: false,
        steps: lesson.steps.map(s => defaultExerciseProgress(s.id))
    };
}
export function lessonProgressWithRecord(progress, record) {
    const steps = progress.steps.map((s) => s.exerciseId == record.exerciseId
        ? exerciseProgressWithRecord(s, omit(record, 'exerciseId'))
        : s);
    const keyStep = steps.at(-1);
    if (keyStep == null) {
        return progress;
    }
    const rating = keyStep.grade;
    const passed = keyStep.passed;
    return {
        lessonId: progress.lessonId,
        rating, passed,
        steps
    };
}
//# sourceMappingURL=LessonProgress.js.map